import { CoordinatorService } from "./coordinator.service"
import { TableRow } from "./table-row"
import { FieldType, TAGTEMPL } from "./template-repository$";
;
// import { TableInput } from "./table-input";

export class TableCell {
    tag: string
    searchTag: string | undefined
    type: FieldType
    label: string
    // row: TableRow
    isEditable: boolean
    mustHaveValue: boolean

    constructor(private coords: CoordinatorService,
        public tblr: TableRow, params: TAGTEMPL) {
        this.tag = params.tag
        this.searchTag = params.searchTag
        this.type = params.type || "string"
        this.label = params.label || this.tag

        this.isEditable = params.isEditable === undefined
            ? true : params.isEditable

        this.mustHaveValue = params.mustHaveValue === true
    }
}
